module.exports = __webpack_public_path__ + "img/Weapon_61.291a31c0.png";